var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SpecialOffer container_w dis_bo"},[_c('bread-crumb'),_c('page-header',{attrs:{"headerTitle":_vm.headerTitle}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.detailHtml)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }